<template>
  <div>
    <div class="manageBody">
      <!-- 新建班级按钮 -->
      <el-button
        type="primary"
        @click="newClassF"
        class="fl"
        style="margin: 15px 15px 0 0"
        >新建班级</el-button
      >
      <!-- 班级列表 -->
      <div id="tabsNav">
        <el-tabs
          class="fl"
          style="width: 1085px"
          v-model="activeName"
          @tab-click="tabClick"
        >
          <el-tab-pane
            :title="i.classname"
            v-for="i in classList"
            :key="i.class_id"
            :label="i.classname"
            :name="i.class_id"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog
      title="新建班级"
      :visible.sync="newClass"
      custom-class="nbDialog"
      width="500px"
      :close-on-press-escape="firstOne"
      :close-on-click-modal="firstOne"
      :show-close="true"
    >
      <div style="width: 265px; margin: auto">
        <div style="margin-top: 20px">
          <el-form :model="from" :rules="rules" ref="ruleForm">
            <el-form-item label="" prop="input">
              <el-input
                v-model="from.input"
                placeholder="请输入班级名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="newClass = false">取 消</el-button>
          <el-button
            type="primary"
            :loading="btnLoading"
            @click="addToClass('ruleForm')"
            >确 定</el-button
          >
        </div>
      </span>
    </el-dialog>

    <!--加入班级指南-->
    <el-dialog
      title="加入班级指南"
      :visible.sync="joinGuide"
      custom-class="nbDialog"
      width="500px"
    >
      <div class="joinNum">
        <span>班级编号：</span>
        <span>{{ classInfo.class_code }}</span>
      </div>
      <div class="joinText">
        <div>
          <i>1</i>
          <span
            >将“班级编号：{{
              classInfo.class_code
            }}”写在黑板上或发送给需要加入的学生</span
          >
        </div>
        <div>
          <i>2</i>
          <span>
            让学生使用电脑访问网址并使用给定的帐号密码登录：{{ examUrl }}
          </span>
        </div>
        <div>
          <i>3</i>
          <span
            >让学生点击右上角的“个人中心”按钮，进入后填写班级编号，搜索班级加入</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <div>
          <el-button @click="joinGuide = false">知道了</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
import { addclass, getclasslist } from "./../../api/exam_api";
export default {
  props: ["message"],
  data() {
    return {
      schoolId: 0,
      examUrl: "",
      classInfo: {},
      joinGuide: false,
      firstOne: true,
      activeName: undefined,
      nbTagstype: "",
      classList: [],
      newClass: false,
      from: {
        input: "",
      },
      btnLoading: false,
      rules: {
        input: [
          { required: true, message: "请输入班级名称", trigger: "blur" },
          { min: 2, max: 10, message: "班级名称应为2到10位", trigger: "blur" },
        ],
      },
      nbTagsNum: 0,
    };
  },
  methods: {
    addToClass(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          addclass({
            name: this.from.input,
            schoolId: this.schoolId,
            pid: this.GLOBAL.pid,
          }).then((res) => {
            if (res.code == 0) {
              this.newClass = false;
              this.btnLoading = false;
              this.input = "";
              this.classListF(-1);
              this.$message({
                message: "新建成功",
                type: "success",
              });
              this.classInfo = res.data;
              this.examUrl = studentNum.app_url;
              this.joinGuide = true;
              this.firstOne = true;
            } else {
              this.btnLoading = false;
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    tabClick(data) {
      window.sessionStorage.activeName = this.activeName;
      this.nbTagsNum++;
      this.nbTagstype = this.activeName;
      // debugge
      this.$router.push({
        path: "/manageclass",
        query: { plan: this.activeName },
      });
      this.GLOBAL.nowClass = data.paneName;
      this.$emit("child-data", this.activeName, this.classList);
    },
    classListF($type, classId) {
      const loadingInstance =  Loading.service({
        target: "#nbBody"
      });
      getclasslist().then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            // debugger;
            for (let i = 0; i < res.data.length; i++) {
              res.data[i].class_id = res.data[i].id.toString();
            }
            if ($type == -1) {
              let i = res.data.length - 1;
              this.activeName = res.data[i].class_id;
              this.$emit("child-data", this.activeName, this.classList);
              this.$router.push({
                path: "/manageclass",
                query: { plan: this.activeName },
              });
            } else if ($type == -2) {
              this.activeName = res.data[0].classname;
              this.$emit("child-data", this.activeName, this.classList);
              this.$router.push({
                path: "/manageclass",
                query: { plan: this.activeName },
              });
            } else {
              if (this.activeName == 0) {
                this.activeName = res.data[0].class_id;
              }
              if (this.nbTagsNum == 0) {
                this.$emit("child-data", this.activeName, res.data);
              } else {
                this.$emit("child-data", this.activeName, this.classList);
              }
            }
            this.classList = res.data;
            for (let i = 0; i < this.classList.length; i++) {
              this.classList[i].classname = this.classList[i].name;
              this.classList[i].class_id = this.classList[i].id.toString();
            }
          } else {
            this.firstOne = false;
            let _href = window.location.href;
            if (_href.indexOf("manageclass") != -1) {
              this.newClass = true;
            }
          }
        }
      });
      loadingInstance.close();
    },
    newClassF() {
      this.newClass = true;
    },
  },
  mounted() {
    this.schoolId = this.GLOBAL.userInfo.schoolInfo.id;
    let _url = window.location.href;
    let Back = _url.indexOf("backClass");
    let str = "";
    if (this.$route.query.plan && this.activeName) {
      this.activeName = this.$route.query.plan;
    }
    if (Back != -1) {
      let start = _url.indexOf("plan=");
      str = _url.substr(start + 5, _url.length);
      this.classListF(-2, str);
    } else {
      this.classListF();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/assets/js/pages/common/NbTags.vue